(function($) {

  $('#youtube-slider').flexslider({
    animation: 'slide',
    controlNav: true,
    
  });
  
})(jQuery);